import { useEffect, useState } from "react";
import { Table, Button, Modal, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import CustomerService from "../../services/CustomerService";
import Lodder from "../../components/Lodder";
import customerServices from "../../services/CustomerService";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const location = useLocation();
  const [fileList, setFileList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    document.title = "Dashboard";
    fetchFiles();
    checkShowWelcome();
  }, []);

  const checkShowWelcome = () => {
    const searchParams = new URLSearchParams(location.search);
    const showWelcome = searchParams.get("showWelcome");
    if (showWelcome === "true") {
      setShowWelcomeModal(true);
    }
  };

  const handleWelcomeModalClose = () => {
    setShowWelcomeModal(false);
  };

  const fetchFiles = () => {
    setShowLoader(true);
    customerServices
      .GetCustomerAgreements()
      .then((response) => {
        if (response.status) {
          const files = response.resultData || [];
          const remainingFiles = files.filter(
            (f) => !f.filePath.startsWith('KasperAgreement')
          );
          setFileList(remainingFiles);
        }
      })
      .finally(() => {
        setShowLoader(false);
      });
    setShowLoader(false);
  };

  const handleUpload = ({ file }) => {
    setShowLoader(true);
    customerServices
      .UploadDocument(file)
      .then((response) => {
        if (response.status) {
          message.success("File uploaded successfully");
          fetchFiles();
        } else {
          message.error("Upload failed");
        }
      })
      .finally(() => {
        setShowLoader(false);
        setModalVisible(false);
      });
  };

  const handleDelete = (id) => {
    setShowLoader(true);
    customerServices
      .DeleteDocument(id)
      .then(() => {
        message.success("File deleted successfully");
        fetchFiles();
      })
      .catch(() => message.error("Deletion failed"))
      .finally(() => setShowLoader(false));
  };

  const showDeleteConfirm = (id) => {
    Modal.confirm({
      title: (
        <div style={{ position: "relative" }}>
          <span>Are you sure you want to delete this document?</span>
          <CloseOutlined
            style={{ position: "absolute", top: "-8px", right: "-10px" }}
            onClick={() => Modal.destroyAll()}
          />
        </div>
      ),
      icon: <DeleteOutlined />,
      okText: "YES",
      okType: "default",
      cancelText: "NO",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleView = (id) => {
    setShowLoader(true);
    customerServices
      .viewDocument(id)
      .then((res) => {
        if (res.resultData != null) {
          window.open(`${res.resultData}`, "_blank");
          message.success("File opened in new tab");
        } else {
          message.error("No file path received");
        }
      })
      .catch(() => message.error("Error opening file"))
      .finally(() => setShowLoader(false));
  };

  const columns = [
    {
      title: "ID",
      render: (_, __, index) => index + 1,
      width: 50,
    },
    {
      title: "File Name",
      dataIndex: "agreementName",
      key: "agreementName",
      sorter: (a, b) => a.agreementName.localeCompare(b.agreementName),
      width: 500,
    },
    {
      title: "Upload Date/Time",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
      render: (date) => {
        return (
          <>
            {new Date(date).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </>
        );
      },
      width: 200,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex">
          <button
            className="submit-button"
            onClick={() => showDeleteConfirm(record.id)}
          >
            Delete
          </button>
          <button
            className="submit-button mx-3"
            onClick={() => handleView(record.id)}
          >
            View
          </button>
        </div>
      ),
      width: 120,
    },
  ];

  return (
    <>
      <Lodder show={showLoader} />
      <Modal
        visible={showWelcomeModal}
        onCancel={handleWelcomeModalClose}
        footer={null}
        centered
        maskClosable={false}
        closable={true}
        closeIcon={<CloseOutlined style={{ fontSize: '20px' }} />}
        width={400}
        bodyStyle={{ padding: '30px', textAlign: 'center' }}
      >
        <h2 className="display-4" id="main-font">Welcome to Pro Slay</h2>
        <button 
          onClick={handleWelcomeModalClose}
          className="submit-button"
        >
          View Dashboard
        </button>
      </Modal>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            <div className="row mx-lg-3 mx-0">
              <div className="col-sm-6">
                <h1 className="m-0">DASHBOARD</h1>
              </div>
              <div className="col-sm-6 d-flex justify-content-end">
                <button
                  className="submit-button"
                  onClick={() => setModalVisible(true)}
                >
                  Upload Document
                </button>
              </div>
            </div>
          </div>
        </div>

        <section className="content mt-3">
          <div className="container-fluid">
            <div className="row mx-lg-3 mx-0">
              <div className="col-12">
                <div className="card border-0 shadow card-span w-100">
                  <div className="card-header property-header py-3">
                    <h5 className="mb-0 property-heading-card">DOCUMENTS</h5>
                  </div>
                  <div className="p-4 mt-2 table-responsive">
                    <Table
                      dataSource={fileList}
                      columns={columns}
                      rowKey="id"
                      pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ["5", "10", "20", "50"],
                        defaultPageSize: 10,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        title="Upload Document"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Upload
          customRequest={handleUpload}
          showUploadList={false}
          accept=".pdf,.doc,.docx,.jpg,.png"
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Modal>
    </>
  );
};

export default Dashboard;
